import React from 'react';
import { graphql } from 'gatsby';

import Layout from '../../layouts/default';
import SEO from '../../components/seo';
import HeaderText from './header/text';
import HeaderImage from './header/image';
import HeaderCarousel from './header/carousel';

import Bricks from '../../components/structural/bricks';

import './page.scss';

const PageTemplate = ({ data }) => {
  const eckHeader = {
    title: data.allNodePage.edges[0].node.title,
    type: data.allNodePage.edges[0].node.relationships
      .field_page_header[0]
      ? data.allNodePage.edges[0].node.relationships
          .field_page_header[0].internal.type
      : null,
    data: data.allNodePage.edges[0].node.relationships
      .field_page_header[0],
  };

  const eckBody = {
    depths: data.allNodePage.edges[0].node.field_page_body,
    bricks:
      data.allNodePage.edges[0].node.relationships.field_page_body,
  };

  // Handle Bricks formatting and mapping //
  const merge = (a, b) => {
    let rtn = [];
    for (var i = 0; i < a.length; i++) {
      rtn.push({
        depth: a[i].depth,
        brick: b[i],
      });
    }
    return rtn;
  };
  var input = merge(eckBody.depths, eckBody.bricks);
  var bricks = [];
  var parents = [bricks];
  for (var el of input) {
    let nv = {
      type: el.brick.internal.type,
      id: el.brick.drupal_id,
      children: [],
    };
    parents[el.depth].push(nv);
    parents[++el.depth] = nv.children;
  }
  // \END Handle bricks formatting and mapping //

  return (
    <Layout>
      <SEO title={data.allNodePage.edges[0].node.title} />
      <Header data={eckHeader} />
      <Bricks bricks={bricks} />
    </Layout>
  );
};

const Header = (props) => {
  switch (props.data.type) {
    case 'eck_page_header__image':
      return <HeaderImage data={props.data} />;
    case 'eck_page_header__carousel':
      return <HeaderCarousel data={props.data} />;
    default:
      return <HeaderText data={props.data} />;
  }
};

export default PageTemplate;

// BabelPluginRemoveGraphQLQueries:
// String interpolations are not allowed in graphql fragments.
// Included fragments should be referenced as `...MyModule_foo`.

export const query = graphql`query ($id: String!) {
  allNodePage(filter: {id: {eq: $id}}) {
    edges {
      node {
        id
        title
        field_page_body {
          depth
        }
        relationships {
          field_page_body {
            ... on eck_page_body__section {
              drupal_id
              internal {
                type
              }
            }
            ... on eck_page_body__container {
              drupal_id
              internal {
                type
              }
            }
            ... on eck_page_body__column {
              drupal_id
              internal {
                type
              }
            }
          }
          field_page_header {
            ... on eck_page_header__carousel {
              internal {
                type
              }
              relationships {
                field_slide_s {
                  field_background_color {
                    color
                    opacity
                  }
                  relationships {
                    field_image {
                      field_media_image {
                        alt
                      }
                      relationships {
                        field_media_image {
                          localFile {
                            childImageSharp {
                              gatsbyImageData(layout: FULL_WIDTH)
                            }
                          }
                        }
                      }
                    }
                    field_image_overlay {
                      field_media_image {
                        alt
                      }
                      relationships {
                        field_media_image {
                          localFile {
                            childImageSharp {
                              gatsbyImageData(width: 800, layout: CONSTRAINED)
                            }
                          }
                        }
                      }
                    }
                    field_caption {
                      ... on paragraph__component_heading {
                        internal {
                          type
                        }
                        field_heading
                        field_heading_type
                      }
                      ... on paragraph__component_paragraph_s {
                        internal {
                          type
                        }
                        relationships {
                          field_paragraph_s {
                            field_paragraph
                          }
                        }
                      }
                      ... on paragraph__component_button_s {
                        internal {
                          type
                        }
                        relationships {
                          field_button_s {
                            field_link {
                              title
                              uri
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
            ... on eck_page_header__image {
              internal {
                type
              }
              field_background_color {
                color
                opacity
              }
              relationships {
                field_image {
                  field_media_image {
                    alt
                  }
                  relationships {
                    field_media_image {
                      localFile {
                        childImageSharp {
                          gatsbyImageData(layout: FULL_WIDTH)
                        }
                      }
                    }
                  }
                }
                field_caption {
                  ... on paragraph__component_heading {
                    internal {
                      type
                    }
                    field_heading
                    field_heading_type
                  }
                  ... on paragraph__component_paragraph_s {
                    internal {
                      type
                    }
                    relationships {
                      field_paragraph_s {
                        field_paragraph
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  }
}
`;
// const HeaderText = props => {
// 	console.log(props)

// 		return (
// 			<p>sdf</p>
// 			// <section className={"dark"} style={{background: "#1b75bb"}}>
// 			// 	<Container>
// 			// 		<Row>
// 			// 			<Col>
// 			// 				<h1>{this.props.data.title}</h1>
// 			// 			</Col>
// 			// 		</Row>
// 			// 	</Container>
// 			// </section>
// 		)

// }
